<template>
  <div class="inline-flex justify-center items-center h-[110px] w-[110px] relative">
    <FaSharpSolidBookmark
      class="absolute top-0 left-0 text-medium-blue"
      fill="currentColor"
    />
    <h4 class="relative text-white font-medium mb-0 text-center mt-4 pt-1">
      {{ text }}
    </h4>
  </div>
</template>

<script>
import FaSharpSolidBookmark from '@fortawesome/fontawesome-pro/svgs/sharp-solid/bookmark.svg'

export default defineNuxtComponent({
  components: {
    FaSharpSolidBookmark,
  },

  props: {
    text: {
      type: String,
      required: true,
    },
  },
})
</script>
